<template>
    <div>
        <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"></loading>

        <b-form @submit.stop.prevent="guardar">
            <b-container fluid>

                <fieldset>
                    <legend>Datos de la clínica</legend>
                    <b-row align-v="center">

                       <b-col cols="6">
                            <b-form-group align="left">
                                <label>Número de sillones
                                    <validacion/>
                                </label>
                                <b-input-group size="sm" class="mb-2">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="menu-button-wide"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input
                                            placeholder="Ingresa el número de sillones"
                                            :state="validateState('numeroSillones')"
                                            v-model="$v.objGuardar.numeroSillones.$model"
                                            type="number"
                                    ></b-form-input>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </fieldset>

            </b-container>
            <b-button id="submitGuardar" ref="submitGuardar" type="submit" style="visibility: hidden"
                      v-if="$localStorageService.can('BO_28_clini_sillon')"></b-button>
        </b-form>
    </div>
</template>

<script>
    import {validationMixin} from "vuelidate";
    import {required, maxLength} from "vuelidate/lib/validators";

    export default {
        components: {},
        props: {
            clinicaOriginal: Object
        },
        mixins: [validationMixin],
        data() {
            return {
              version: process.env.VUE_APP_ENV_VERSION,
              debug: false,

                loading: false,
                mostrarModal: false,

                objGuardar: {
                    idClinica: null,
                    numeroSillones: null
                }
            };
        },
        validations: {
            objGuardar: {
                numeroSillones: {required, maxLength: maxLength(5)}
            }
        },
        created() {
          this.debug = this.$localStorageService.getDebug();

            this.$nextTick(() => {
                this.$v.$reset()
            });
            this.crearClinica();
        },
        methods: {
            validateState(name) {
                const {$dirty, $error} = this.$v.objGuardar[name];
                return $dirty ? !$error : null;
            },
            crearClinica() {
                this.objGuardar = JSON.parse(JSON.stringify(this.clinicaOriginal));
            },
            guardar() {

                this.$v.objGuardar.$touch();
                if (this.$v.objGuardar.$anyError) {
                    return;
                }

              this.objGuardar.opcionGuardar = 2;

                this.loading = true;
                this.$http
                    .post(this.$api + "catalogos/crearClinica", this.objGuardar)
                    .then((response) => {
                        if (response.status === 200) {
                            this.$swal.fire({
                                position: "center",
                                icon: "success",
                                title: "Clinica registrada correctamente ",
                                showConfirmButton: false,
                                timer: 3500,
                            });

                            this.$nextTick(() => {
                                this.$v.$reset()
                            });


                            this.$emit("actualizar", this.objGuardar.strNombre);
                            this.objGuardar = {};
                        }
                    }).catch((error)=>{
                  console.error(error);
                    this.$swal.fire({
                        position: "center",
                        icon: "error",
                        title: "Ocurrio un error al registrar la clínica",
                        showConfirmButton: false,
                        timer: 3500,
                    });
                }).finally(() => {
                    this.loading = false;
                });
            }
        },

    };
</script>
